import { Drawer, List } from "antd"
import { useTranslation } from "react-i18next"

const CardInfoDrawer = ({ drawerVisible, setDrawerVisible, hwVer, swVer, cardID }) => {
    const onCloseDrawer = () => setDrawerVisible(false)
    const { t } = useTranslation()

    function base64ToBase16(base64) {
        return window.atob(base64)
            .split('')
            .map(function (aChar) {
                return ('0' + aChar.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
            .toUpperCase().substring(0, 24);
    }


    const items = ["hwver", "swver", "cardid"]
    const values = new Array(hwVer, swVer, base64ToBase16(cardID))

    return (
        <Drawer
            title={t("page.card-details.settings.info.title")}
            placement="right"
            closable={true}
            onClose={onCloseDrawer}
            open={drawerVisible}
            style={{ position: "absolute" }}
        >
            <List mode="inline">
                {items.map((i, idx) => (
                    <List.Item key={i}>{t(`page.card-details.settings.info.${i}`) + " " + values[idx]} </List.Item>
                ))}
            </List>
        </Drawer>
    )
}
export default CardInfoDrawer
